import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_material_packagings_grid_ComponentContextService } from './FootprintManager.material_packagings_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Materials_packages_excl_materials_dd_singleComponent } from './Materials.packages_excl_materials_dd_single.component'
import { Materials_material_packagings_dd_singleComponent } from './Materials.material_packagings_dd_single.component'
import { Materials_decimal_precision_singleComponent } from './Materials.decimal_precision_single.component'
import { Materials_measurement_units_dd_singleComponent } from './Materials.measurement_units_dd_single.component'


interface IFootprintManager_material_packagings_gridComponentEntity {
  MaterialId?: number, PackagingId?: number, AutogenerateSerialNumbers?: boolean, DimensionUomId?: number, Height?: number, IsOrderDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, QuantityPrecisionScale?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, SubPackagingQuantity?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }, SubPackaging?: { Id?: number, ShortName?: string }, Material?: { Id?: number, IsFinishedGood?: boolean, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean }}

interface IFootprintManager_material_packagings_gridComponentInParams {
  materialId?: number}


class FootprintManager_material_packagings_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_material_packagings_gridComponent;
  entity: IFootprintManager_material_packagings_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    packaging_short_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    sub_packaging_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    sub_uom_quantity_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    default_packaging_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    default_packaging_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    decimal_precision_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    upc_code_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    dimension_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_uom_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_high_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_tie_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    ready_to_ship_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    ready_to_ship_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    autogenerate_serial_numbers_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    autogenerate_serial_numbers_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    stackable_group_id_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    packaging_short_name: null,
    sub_packaging: null,
    sub_uom_quantity: null,
    default_packaging: null,
    decimal_precision: null,
    upc_code: null,
    length: null,
    width: null,
    height: null,
    dimension_uom: null,
    weight: null,
    shipping_weight: null,
    weight_uom: null,
    volume: null,
    shipping_volume: null,
    volume_uom: null,
    pallet_high: null,
    pallet_tie: null,
    ready_to_ship: null,
    autogenerate_serial_numbers: null,
    stackable_group_id: null,
  }

  get $fields_packaging_short_name_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.materialId;
    
    return expr;
  }
  get $fields_sub_packaging_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.materialId;
    
    return expr;
  }
  get $fields_dimension_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_weight_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 3;
    
    return expr;
  }
  get $fields_volume_uom_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 2;
    
    return expr;
  }


  constructor(
    grid: FootprintManager_material_packagings_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_material_packagings_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.packaging_short_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging_short_name,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['packaging_short_name_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.sub_packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.sub_packaging,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['sub_packaging_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.sub_uom_quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.sub_uom_quantity,
      new TextModel(null, null,  'number', '0', null)
,
      new NumberBoxModel(this.formGroup.controls['sub_uom_quantity_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.default_packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.default_packaging,
      new CheckBoxModel(this.formGroup.controls['default_packaging_display'] as DatexFormControl, null, true, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['default_packaging_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.decimal_precision = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.decimal_precision,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['decimal_precision_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.upc_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.upc_code,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['upc_code_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.length,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['length_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.width,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['width_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.height,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['height_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.dimension_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.dimension_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['dimension_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['weight_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.shipping_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_weight,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_weight_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['weight_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['volume_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.shipping_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.shipping_volume,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['shipping_volume_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.volume_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['volume_uom_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.pallet_high = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pallet_high,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_high_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.pallet_tie = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.pallet_tie,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['pallet_tie_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.ready_to_ship = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.ready_to_ship,
      new CheckBoxModel(this.formGroup.controls['ready_to_ship_display'] as DatexFormControl, null, false, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['ready_to_ship_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.autogenerate_serial_numbers = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.autogenerate_serial_numbers,
      new CheckBoxModel(this.formGroup.controls['autogenerate_serial_numbers_display'] as DatexFormControl, null, false, false, '', null)
,
      new CheckBoxModel(this.formGroup.controls['autogenerate_serial_numbers_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.stackable_group_id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.stackable_group_id,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['stackable_group_id_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_material_packagings_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_material_packagings_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'MaterialId',this.entity.MaterialId);
    set($resultKey, 'PackagingId',this.entity.PackagingId);
    const inParams = {
      $keys:[$resultKey],
      materialId:  $grid.inParams.materialId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.Materials.ds_material_packagings_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_material_packagings_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.packaging_short_name.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.packaging_short_name.editControl as SelectBoxModel).reset($row.entity.PackagingId);
    (this.cells.sub_packaging.displayControl as TextModel).text = $row.entity.SubPackaging?.ShortName;
    (this.cells.sub_packaging.editControl as SelectBoxModel).reset($row.entity.SubPackaging?.Id);
    (this.cells.sub_uom_quantity.displayControl as TextModel).text = $row.entity.SubPackagingQuantity?.toString();
    (this.cells.sub_uom_quantity.editControl as NumberBoxModel).reset($row.entity.SubPackagingQuantity);
    (this.cells.default_packaging.displayControl as CheckBoxModel).reset($row.entity.IsOrderDefault);
    (this.cells.default_packaging.editControl as CheckBoxModel).reset($row.entity.IsOrderDefault);
    (this.cells.decimal_precision.editControl as SelectBoxModel).reset($row.entity.QuantityPrecisionScale);
    (this.cells.upc_code.displayControl as TextModel).text = $row.entity.UpcCode;
    (this.cells.upc_code.editControl as TextBoxModel).reset($row.entity.UpcCode);
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.length.editControl as NumberBoxModel).reset($row.entity.Length);
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.width.editControl as NumberBoxModel).reset($row.entity.Width);
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.height.editControl as NumberBoxModel).reset($row.entity.Height);
    (this.cells.dimension_uom.displayControl as TextModel).text = $row.entity.DimensionsUom?.Short_name;
    (this.cells.dimension_uom.editControl as SelectBoxModel).reset($row.entity.DimensionUomId);
    (this.cells.weight.displayControl as TextModel).text = $row.entity.Weight?.toString();
    (this.cells.weight.editControl as NumberBoxModel).reset($row.entity.Weight);
    (this.cells.shipping_weight.displayControl as TextModel).text = $row.entity.ShippingWeight?.toString();
    (this.cells.shipping_weight.editControl as NumberBoxModel).reset($row.entity.ShippingWeight);
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.weight_uom.editControl as SelectBoxModel).reset($row.entity.WeightUomId);
    (this.cells.volume.displayControl as TextModel).text = $row.entity.Volume?.toString();
    (this.cells.volume.editControl as NumberBoxModel).reset($row.entity.Volume);
    (this.cells.shipping_volume.displayControl as TextModel).text = $row.entity.ShippingVolume?.toString();
    (this.cells.shipping_volume.editControl as NumberBoxModel).reset($row.entity.ShippingVolume);
    (this.cells.volume_uom.displayControl as TextModel).text = $row.entity.VolumeUom?.Short_name;
    (this.cells.volume_uom.editControl as SelectBoxModel).reset($row.entity.VolumeUomId);
    (this.cells.pallet_high.displayControl as TextModel).text = $row.entity.PalletHigh?.toString();
    (this.cells.pallet_high.editControl as NumberBoxModel).reset($row.entity.PalletHigh);
    (this.cells.pallet_tie.displayControl as TextModel).text = $row.entity.PalletTie?.toString();
    (this.cells.pallet_tie.editControl as NumberBoxModel).reset($row.entity.PalletTie);
    (this.cells.ready_to_ship.displayControl as CheckBoxModel).reset($row.entity?.UseAsShippingContainer);
    (this.cells.ready_to_ship.editControl as CheckBoxModel).reset($row.entity?.UseAsShippingContainer);
    (this.cells.autogenerate_serial_numbers.displayControl as CheckBoxModel).reset($row.entity.AutogenerateSerialNumbers);
    (this.cells.autogenerate_serial_numbers.editControl as CheckBoxModel).reset($row.entity.AutogenerateSerialNumbers);
    (this.cells.stackable_group_id.displayControl as TextModel).text = $row.entity.StackableGroupId;
    (this.cells.stackable_group_id.editControl as TextBoxModel).reset($row.entity.StackableGroupId);

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_material_packagings_gridComponentRowModel,
  $grid: FootprintManager_material_packagings_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_packagings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  let payloadpackaging: any = {};
  
  
  if ($row.cells.length?.editControl.isChanged) {
      payloadpackaging.Length = $row.cells.length?.editControl.value;
  }
  if ($row.cells.width?.editControl.isChanged) {
      payloadpackaging.Width = $row.cells.width?.editControl.value;
  }
  if ($row.cells.height?.editControl.isChanged) {
      payloadpackaging.Height = $row.cells.height?.editControl.value;
  }
  if ($row.cells.dimension_uom?.editControl.isChanged) {
      payloadpackaging.DimensionUomId = $row.cells.dimension_uom?.editControl.value;
  }
  
  if ($row.cells.weight?.editControl.isChanged) {
      if (($row.cells.weight?.editControl.value <=0) ) {
          await $shell.FootprintManager.openErrorDialog(`Error on save`, `Weight must be greater than 0`);
          throw new Error(`Weight must be greater than 0`)
      } else {
          payloadpackaging.Weight = $row.cells.weight?.editControl.value;
      }
  }
  
  if ($row.cells.weight?.editControl.isChanged) {
      if ( $row.cells.shipping_weight?.editControl.value < $row.cells.weight?.editControl.value)  {
          await $shell.FootprintManager.openErrorDialog(`Error on save`, `Weight must be equal to or less than the shipping weight`);
          throw new Error(`Weight must be equal to or less than the shipping weight`)
      } else {
          payloadpackaging.Weight = $row.cells.weight?.editControl.value;
      }
  }
  
  if ($row.cells.shipping_weight?.editControl.isChanged) {
      if ($row.cells.shipping_weight?.editControl.value <=0) {
          await $shell.FootprintManager.openErrorDialog(`Error on save`, `Shipping weight must be greater than 0`);
          throw new Error(`Shipping weight must be greater than 0`)
      } else {
          payloadpackaging.ShippingWeight = $row.cells.shipping_weight?.editControl.value;
      }
  }
  
  
  if ($row.cells.shipping_weight?.editControl.isChanged) {
      if ( $row.cells.shipping_weight?.editControl.value < $row.cells.weight?.editControl.value) {
          await $shell.FootprintManager.openErrorDialog(`Error on save`, `Shipping weight must be equal to or greater than the weight`);
          throw new Error(`Shipping weight must be equal to or greater than the weight`)
      } else {
          payloadpackaging.ShippingWeight = $row.cells.shipping_weight?.editControl.value;
      }
  }
  
  
  
  
  
  if ($row.cells.weight_uom?.editControl.isChanged) {
      payloadpackaging.WeightUomId = $row.cells.weight_uom?.editControl.value;
  }
  if ($row.cells.volume?.editControl.isChanged) {
      payloadpackaging.Volume = $row.cells.volume?.editControl.value;
  }
  if ($row.cells.shipping_volume?.editControl.isChanged) {
      if ($row.cells.shipping_volume?.editControl.value < $row.cells.volume?.editControl.value) {
          await $shell.Materials.openErrorDialog(`Error on save`, `Shipping volume must be equal to or greater than the volume`);
          throw new Error(`Shipping volume must be equal to or greater than the volume`)
      } else {
          payloadpackaging.ShippingVolume = $row.cells.shipping_volume?.editControl.value;
      }
  }
  
  
  
  if ($row.cells.volume_uom?.editControl.isChanged) {
      payloadpackaging.VolumeUomId = $row.cells.volume_uom?.editControl.value;
  }
  if ($row.cells.pallet_high?.editControl.isChanged) {
      payloadpackaging.PalletHigh = $row.cells.pallet_high?.editControl.value;
  }
  if ($row.cells.pallet_tie?.editControl.isChanged) {
      payloadpackaging.PalletTie = $row.cells.pallet_tie?.editControl.value;
  }
  if ($row.cells.upc_code?.editControl.isChanged) {
      payloadpackaging.UpcCode = $row.cells.upc_code?.editControl.value;
  }
  
  if ($row.cells.decimal_precision?.editControl.isChanged) {
      payloadpackaging.QuantityPrecisionScale = $row.cells.decimal_precision?.editControl.value;
  }
  
  if ($row.cells.default_packaging?.editControl.isChanged) {
      payloadpackaging.IsOrderDefault = $row.cells.default_packaging?.editControl.value;
  }
  
  if ($row.cells.ready_to_ship?.editControl.isChanged) {
      payloadpackaging.UseAsShippingContainer = $row.cells.ready_to_ship?.editControl.value;
  }
  
  if ($row.cells.autogenerate_serial_numbers?.editControl.isChanged) {
      payloadpackaging.AutogenerateSerialNumbers = $row.cells.autogenerate_serial_numbers?.editControl.value;
  }
  if ($row.cells.stackable_group_id?.editControl.isChanged) {
      payloadpackaging.StackableGroupId = $row.cells.stackable_group_id?.editControl.value;
  }
  
  try {
  
      await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'MaterialsPackagingsLookup',
          entity: payloadpackaging,
          pk1String: 'MaterialId',
          pk1: $row.entity.MaterialId,
          pk2String: 'PackagingId',
          pk2: $row.entity.PackagingId
      })
  
      if ($row.cells.default_packaging?.editControl.isChanged) {
  
          const packagings = (await $datasources.Materials.ds_get_material_packagings_by_materialId.get({ materialId: $row.entity.MaterialId })).result;
          if ($utils.isDefined(packagings)) {
  
              for (let packaging of packagings) {
  
                  let packagingId = packaging.PackagingId
  
                  if (packagingId != $row.entity.PackagingId) {
  
                      let payloadpackaging: any = {};
                      payloadpackaging.IsOrderDefault = false;
  
                      await $flows.Utilities.crud_update_dual_pk_flow({
                          entitySet: 'MaterialsPackagingsLookup',
                          entity: payloadpackaging,
                          pk1String: 'MaterialId',
                          pk1: $row.entity.MaterialId,
                          pk2String: 'PackagingId',
                          pk2: packagingId
                      })
                  }
  
              }
  
  
          }
  
      }
  
  
      await $grid.refresh();
  
  }
  catch (error) {
      await $shell.Materials.showErrorDetails('Save', 'Error on save.', error);
      //$shell.Materials.openErrorDialog('Error on save', error.message);
      throw error; // to prevent displayMode 
  }
  
  
  
  
  
  }
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: FootprintManager_material_packagings_gridComponentRowModel,
  $grid: FootprintManager_material_packagings_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_packagings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const materialId = $grid.inParams.materialId
  
  
  $row.entity = {
      MaterialId: materialId
  };
  
  
  
  $row.cells.sub_uom_quantity.editControl.readOnly = false;
  $row.cells.packaging_short_name.editControl.readOnly = false;
  $row.cells.sub_packaging.editControl.readOnly = false;
  
  
  
  const material = (await $datasources.Materials.ds_get_material_by_materialId.get({ materialId: materialId })).result;
  if ($utils.isDefined(material)) {
  
      const materialControllerTypeId = material[0].ControllerTypeId;
      const materialIsFixedWeight = material[0].IsFixedWeight;
      const materialIsFixedLength = material[0].IsFixedLength;
      const materialIsFixedVolume = material[0].IsFixedVolume;
  
      // Serial controlled
      if (materialIsFixedWeight === false || materialControllerTypeId === 3 || materialControllerTypeId === 4 || materialIsFixedLength === false ||
          materialIsFixedVolume === false) {
          $row.cells.decimal_precision.editControl.readOnly = true;
  
      }
  
      else {
          $row.cells.decimal_precision.editControl.readOnly = false;
      }
  
  }
  
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: FootprintManager_material_packagings_gridComponentRowModel,
  $grid: FootprintManager_material_packagings_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_packagings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var requiredFields: [control: string, display: string][];
  var missingRequiredFields: string[] = [];
  
  requiredFields = [
      [$row.cells.packaging_short_name.editControl.value, $grid.headers.packaging_short_name.name],
      [$row.cells.sub_packaging.editControl.value, $grid.headers.sub_packaging.name],
      [$row.cells.sub_uom_quantity.editControl.value, $grid.headers.sub_uom_quantity.name]
  ]
  
  for (let required of requiredFields) {
      if (!$utils.isDefined(required[0])) {
          missingRequiredFields.push(required[1])
      }
  }
  
  if (missingRequiredFields.length === 1) {
      $shell.Materials.openErrorDialog('Save', `Missing Required field: ${missingRequiredFields.join('\r\n').trim().toUpperCase()}`);
      throw new Error(`Missing Required field: ${missingRequiredFields.join('\r\n').trim().toUpperCase()}`); // to prevent displayMode 
  
  } else if (missingRequiredFields.length > 1) {
      $shell.Materials.openErrorDialog('Save', `Missing Required fields: ${missingRequiredFields.join(' & ').trim().toUpperCase()}`);
      throw new Error(`Missing Required fields: ${missingRequiredFields.join(' & ').trim().toUpperCase()}`); // to prevent displayMode 
  }
  
  const base = (await $datasources.Materials.ds_get_materials_basepackaging_by_materialId.get({ materialId: $grid.inParams.materialId })).result;
  if ($utils.isDefined(base)) {
  
      var basePackagingId = base.PackagingId
  }
  
  const subPackaging = (await $datasources.Materials.ds_get_material_packaging_by_materialId_and_packagingId.get({
      materialId: $grid.inParams.materialId,
      packagingId: $row.cells.sub_packaging.editControl.value
  })).result;
  
  if ($utils.isDefined(subPackaging)) {
      var basePackagingQty = subPackaging[0].BasePackagingQuantity * $row.cells.sub_uom_quantity.editControl.value
  }
  
  if (!$utils.isAllDefined(basePackagingId, basePackagingQty)) {
      $shell.Materials.openErrorDialog('Save', 'Cannot Calculate Base Packaging Data');
      throw new Error('Cannot Calculate Base Packaging Data'); // to prevent displayMode 
  }
  
  if (($row.cells.weight.editControl.value ?? 1)>($row.cells.shipping_weight.editControl.value ?? 1)) {
      $shell.Materials.openErrorDialog('Save', 'Shipping weight must be equal to or greater than the net weight');
      throw new Error('Shipping weight must be equal to or greater than the net weight'); 
  }
  
  else {
  
      try {
  
  
  
          // Create material, globalmaterial and materialpackaginglookup
          const payloadMaterialPackaging = {
              "MaterialId": $grid.inParams.materialId,
              "PackagingId": $row.cells.packaging_short_name.editControl.value,
              "IsBasePackaging": false,
              "SubPackagingId": $row.cells.sub_packaging.editControl.value,
              "SubPackagingQuantity": $row.cells.sub_uom_quantity.editControl.value,
              "BasePackagingId": basePackagingId,
              "BasePackagingQuantity": basePackagingQty,
  
              "AllowFractions": true,
              "AllowInSalesOrder": true,
              "AllowInPurchaseOrder": true,
              "IsReportingDefault": false,
              "IsOrderDefault": $utils.isDefined($row.cells.default_packaging.editControl.value) ? $row.cells.default_packaging.editControl.value : false,
              "IsLabelCompliant": false,
              "UseAsShippingContainer": $utils.isDefined($row.cells.ready_to_ship.editControl.value) ? $row.cells.ready_to_ship.editControl.value : false,
              "DeprecatedPackaging": false,
              "AllowInMobileSales": false,
  
              "QuantityPrecisionScale": $utils.isDefined($row.cells.decimal_precision.editControl.value) ? $row.cells.decimal_precision.editControl.value : null,
  
              "ShippingWeight": $utils.isDefined($row.cells.shipping_weight.editControl.value) ? $row.cells.shipping_weight.editControl.value : 1,
              "Weight": $utils.isDefined($row.cells.weight.editControl.value) ? $row.cells.weight.editControl.value : 1,
              "TareWeight": 0,
              "WeightUomId": $utils.isDefined($row.cells.weight_uom.editControl.value) ? $row.cells.weight_uom.editControl.value : 14,
  
              "Height": $utils.isDefined($row.cells.height.editControl.value) ? $row.cells.height.editControl.value : 1,
              "Width": $utils.isDefined($row.cells.width.editControl.value) ? $row.cells.width.editControl.value : 1,
              "Length": $utils.isDefined($row.cells.length.editControl.value) ? $row.cells.length.editControl.value : 1,
              "DimensionUomId": $utils.isDefined($row.cells.dimension_uom.editControl.value) ? $row.cells.dimension_uom.editControl.value : 5,
  
              "Volume": $utils.isDefined($row.cells.volume.editControl.value) ? $row.cells.volume.editControl.value : 1,
              "ShippingVolume": $utils.isDefined($row.cells.shipping_volume.editControl.value) ? $row.cells.shipping_volume.editControl.value : 1,
              "VolumeUomId": $utils.isDefined($row.cells.volume_uom.editControl.value) ? $row.cells.volume_uom.editControl.value : 11,
  
              //  "StandardCost": 1,      // Removing cost and price as inventory adjustments are restricted based on allowed adjustment amounts.
              //  "StandardPrice": 1,
  
              "PalletTie": $row.cells.pallet_tie.editControl.value,
              "PalletHigh": $row.cells.pallet_high.editControl.value,
  
              "UpcCode": $row.cells.upc_code.editControl.value,
              "AutogenerateSerialNumbers": $row.cells.autogenerate_serial_numbers.editControl.value,
              "StackableGroupId": $row.cells.stackable_group_id.editControl.value
          };
  
          await $flows.Utilities.crud_create_flow({ entitySet: 'MaterialsPackagingsLookup', entity: payloadMaterialPackaging });
  
          if ($row.cells.default_packaging.editControl.value) {
  
              const packagings = (await $datasources.Materials.ds_get_material_packagings_by_materialId.get({ materialId: $row.entity.MaterialId })).result;
              if ($utils.isDefined(packagings)) {
  
                  for (let packaging of packagings) {
  
                      let packagingId = packaging.PackagingId
  
                      if (packagingId != $row.cells.packaging_short_name.editControl.value) {
  
                          let payloadpackaging: any = {};
                          payloadpackaging.IsOrderDefault = false;
  
                          await $flows.Utilities.crud_update_dual_pk_flow({
                              entitySet: 'MaterialsPackagingsLookup',
                              entity: payloadpackaging,
                              pk1String: 'MaterialId',
                              pk1: $row.entity.MaterialId,
                              pk2String: 'PackagingId',
                              pk2: packagingId
                          })
                      }
  
                  }
  
  
              }
  
          }
  
  
  
          $grid.refresh();
  
      }
      catch (error) {
          $shell.Materials.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  }
  
  
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_material_packagings_gridComponentRowModel,
  $grid: FootprintManager_material_packagings_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_packagings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var materialId = $row.entity.MaterialId;
  
  const material = (await $datasources.Materials.ds_get_material_by_materialId.get({ materialId: materialId })).result;
  if ($utils.isDefined(material)) {
  
      const materialControllerTypeId = material[0].ControllerTypeId;
      const materialIsFixedWeight = material[0].IsFixedWeight;
      const materialIsFixedLength = material[0].IsFixedLength;
      const materialIsFixedVolume = material[0].IsFixedVolume;
  
      // Serial controlled
      if (materialIsFixedWeight === false || materialControllerTypeId === 3 || materialControllerTypeId === 4 || materialIsFixedLength === false ||
          materialIsFixedVolume === false) {
          $row.cells.decimal_precision.editControl.readOnly = true;
  
      }
  
      else {
          $row.cells.decimal_precision.editControl.readOnly = false;
      }
  
  }
  
  
  
  
  if ($utils.isDefined($row.cells.packaging_short_name.displayControl.text)) {
      $row.cells.sub_uom_quantity.editControl.readOnly = true;
      $row.cells.packaging_short_name.editControl.readOnly = true;
      $row.cells.sub_packaging.editControl.readOnly = true;
  } else {
      $row.cells.sub_uom_quantity.editControl.readOnly = false;
      $row.cells.packaging_short_name.editControl.readOnly = false;
      $row.cells.sub_packaging.editControl.readOnly = false;
  }
  
  
  if ($utils.isDefined($row.entity.QuantityPrecisionScale)) {
  
      switch ($row.entity.QuantityPrecisionScale) {
  
          case 1: {
  
              $row.cells.decimal_precision.displayControl.text = '1 decimal place';
              break;
          }
          case 2: {
  
              $row.cells.decimal_precision.displayControl.text = '2 decimal places';
              break;
          }
          case 3: {
  
              $row.cells.decimal_precision.displayControl.text = '3 decimal places';
              break;
          }
          case 4: {
  
              $row.cells.decimal_precision.displayControl.text = '4 decimal places';
              break;
          }
          case 5: {
  
              $row.cells.decimal_precision.displayControl.text = '5 decimal places';
              break;
          }
          case 6: {
  
              $row.cells.decimal_precision.displayControl.text = '6 decimal places';
              break;
          }
          case 7: {
  
              $row.cells.decimal_precision.displayControl.text = '7 decimal places';
              break;
          }
          case 8: {
  
              $row.cells.decimal_precision.displayControl.text = '8 decimal places';
              break;
          }
  
  
  
      }
  }
  
  
  }
  on_check_weight(event = null) {
    return this.on_check_weightInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_check_weightInternal(
    $row: FootprintManager_material_packagings_gridComponentRowModel,
  $grid: FootprintManager_material_packagings_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_packagings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
    this.$logger.log('FootprintManager', 'material_packagings_grid.on_check_weight');
  
      if ( $row.cells.shipping_weight?.editControl.value < $row.cells.weight?.editControl.value) {
          await $shell.FootprintManager.openErrorDialog(`Error on save`, `Weight must be equal to or less than the shipping weight`);
          throw new Error(`Weight must be equal to or less than the shipping weight`)
      }
      
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Materials_packages_excl_materials_dd_singleComponent),
    forwardRef(() => Materials_material_packagings_dd_singleComponent),
    forwardRef(() => Materials_decimal_precision_singleComponent),
    forwardRef(() => Materials_measurement_units_dd_singleComponent),
  ],
  selector: 'FootprintManager-material_packagings_grid',
  templateUrl: './FootprintManager.material_packagings_grid.component.html'
})
export class FootprintManager_material_packagings_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_material_packagings_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_material_packagings_gridComponentInParams = { materialId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     packaging_short_name: new GridHeaderModel(new HeaderStyles(null, null), 'packaging_short_name', 'Packaging', false, false, null, false),       sub_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'sub_packaging', 'Sub-packaging', false, false, null, false),       sub_uom_quantity: new GridHeaderModel(new HeaderStyles(null, null), 'sub_uom_quantity', 'Sub-packaging quantity', false, false, null, false),       default_packaging: new GridHeaderModel(new HeaderStyles(null, null), 'default_packaging', 'Default', false, false, null, false),       decimal_precision: new GridHeaderModel(new HeaderStyles(null, null), 'decimal_precision', 'Decimal precision', false, false, null, false),       upc_code: new GridHeaderModel(new HeaderStyles(null, null), 'upc_code', 'UPC', false, false, null, false),       length: new GridHeaderModel(new HeaderStyles(null, null), 'length', 'Length', false, false, null, false),       width: new GridHeaderModel(new HeaderStyles(null, null), 'width', 'Width', false, false, null, false),       height: new GridHeaderModel(new HeaderStyles(null, null), 'height', 'Height', false, false, null, false),       dimension_uom: new GridHeaderModel(new HeaderStyles(null, null), 'dimension_uom', 'UOM', false, false, null, false),       weight: new GridHeaderModel(new HeaderStyles(null, null), 'weight', 'Weight', false, false, null, false),       shipping_weight: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_weight', 'Shipping weight', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'UOM', false, false, null, false),       volume: new GridHeaderModel(new HeaderStyles(null, null), 'volume', 'Volume', false, false, null, false),       shipping_volume: new GridHeaderModel(new HeaderStyles(null, null), 'shipping_volume', 'Shipping volume', false, false, null, false),       volume_uom: new GridHeaderModel(new HeaderStyles(null, null), 'volume_uom', 'UOM', false, false, null, false),       pallet_high: new GridHeaderModel(new HeaderStyles(null, null), 'pallet_high', 'Pallet high', false, false, null, false),       pallet_tie: new GridHeaderModel(new HeaderStyles(null, null), 'pallet_tie', 'Pallet tie', false, false, null, false),       ready_to_ship: new GridHeaderModel(new HeaderStyles(null, null), 'ready_to_ship', 'Shippable container', false, false, null, false),       autogenerate_serial_numbers: new GridHeaderModel(new HeaderStyles(null, null), 'autogenerate_serial_numbers', 'Autogenerate serials', false, false, null, false),       stackable_group_id: new GridHeaderModel(new HeaderStyles(null, null), 'stackable_group_id', 'Stack group', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_material_packagings_gridComponentRowModel[] = [];

  @Input('materialId') set $inParams_materialId(value: any) {
    this.inParams['materialId'] = value;
  }
  get $inParams_materialId(): any {
    return this.inParams['materialId'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_material_packagings_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Packagings';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      materialId:  $grid.inParams.materialId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.Materials.ds_material_packagings_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_material_packagings_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_material_packagings_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IFootprintManager_material_packagings_gridComponentEntity) {
    const row = new FootprintManager_material_packagings_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_material_packagings_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_packagings_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  // Material catalog lockdown
  let versionCheck = await $flows.Utilities.check_footprint_version({ minimumVersion: '24.10.25' });
  
  if (versionCheck.meetsMinimumVersion) {
  
      // @ts-ignore 
      const material_catalog_details = (await $datasources.Catalogs.ds_get_material_catalog_details_by_material_id.get({ material_id: $grid.inParams.materialId })).result;
      if ($utils.isDefined(material_catalog_details) && $utils.isDefined(material_catalog_details[0]?.MaterialCatalogSourceMaterialId)) {
        
          $grid.canAdd = false;
          $grid.canEdit = false;
      }
  
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
